import propertyUtils from 'app/shared/utils/propertyUtils';

const MarketPropertySelect = ({
    listingAlias = '',
    name = '',
    address = {},
    isMultifamily = false,
} = {}) => ({
    listingAlias: String(listingAlias),
    name: String(name),
    address: propertyUtils.formatAddress(address).formattedCompleteAddress,
    street: address.street,
    city: address.city,
    state: address.state,
    zip: address.zip,
    isMultifamily: Boolean(isMultifamily),
});

const MarketPropertiesSelect = (
    properties = [],
) => ({
    properties: properties.map(MarketPropertySelect),
});

export default MarketPropertiesSelect;
